import { Provider as ProviderV3, defaultTheme } from '@adobe/react-spectrum';
import Provider from '@react/react-spectrum/Provider';
import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { commonApi, publisherApi } from '@exchange-frontends/api';
import { AppCrashComponent, ErrorBoundary, GlobalSkeletonStyles } from '@exchange-frontends/components';
import { makeVersionString } from '@exchange-frontends/utils';

// Local components
import Profile from './profile/Profile';

export const ConfigContext = React.createContext(null);

window.xchgVersions = {
  ...(window.xchgVersions ?? {}),
  publisher: makeVersionString(),
};

/**
 * App component including the router and react-spectrum providers
 * @component
 * @category Publisher
 */
const App = ({ config }) => {
  publisherApi.settings.setEndpoint(config?.apiUrl ?? process.env.ENDPOINT);
  publisherApi.settings.setApiKey(config?.apiKey ?? process.env.API_KEY);
  commonApi.staticDataSettings.setEndpoint(config?.staticDataEndpoint ?? process.env.STATIC_DATA_ENDPOINT);
  commonApi.ccesSettings.setEndpoint(config?.ccesEndpoint ?? process.env.CCES_ENDPOINT);
  commonApi.ccesSettings.setApiKey(config?.ccesApiKey ?? process.env.CCES_API_KEY);
  return (
    <ProviderV3 theme={defaultTheme} colorScheme={`light`}>
      <Provider toastPlacement="bottom center" theme="light">
        <GlobalSkeletonStyles />
        <ErrorBoundary errorComponent={<AppCrashComponent appName="Publisher" />}>
          <Routes>
            <Route
              path="cc/:id/*"
              element={
                <ConfigContext.Provider value={config}>
                  <Profile type="cc" />
                </ConfigContext.Provider>
              }
            />
            <Route
              path="ec/:id/*"
              element={
                <ConfigContext.Provider value={config}>
                  <Profile type="ec" />
                </ConfigContext.Provider>
              }
            />
            <Route
              path="dc/:id/*"
              element={
                <ConfigContext.Provider value={config}>
                  <Profile type="dc" />
                </ConfigContext.Provider>
              }
            />
            <Route path="*" element={<div>/</div>} />
          </Routes>
        </ErrorBoundary>
      </Provider>
    </ProviderV3>
  );
};

export default App;
